import React from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { sendGroupNotificationAction } from '../../../../services/request';
import { Portal, Modal, Box, Stack, Card, CardHeader, CardContent, IconButton, TextField, Button, Typography, Divider, Alert, LinearProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const validationSchema = Yup.object({
  subject: Yup.string().required('To pole nie może być puste'),
  message: Yup.string().required('To pole nie może być puste')
});

export default function SendMessageModal({ open, handleClose, event }) {
  const { error, mutate, loading } = useMutation(sendGroupNotificationAction);

  const handleSubmit = async values => {
    const { error } = await mutate(values);
    if (!error) {
      formik.resetForm();
    }
  };

  const formik = useFormik({
    initialValues: {
      event: _.isNil(event) ? '' : event.id,
      subject: '',
      message: ''
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <Portal>
      <Modal open={open} onClose={handleClose}>
        <Card sx={{ ...style, width: '35vw' }}>
          <CardHeader
            title="Wyślij wiadomość"
            sx={{ textAlign: 'center' }}
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Stack direction="row" justifyContent="left" spacing={4}>
              <Typography variant="body2">zajęcia: <span style={{ fontWeight: 'bold' }}>{event?.name}</span></Typography>
              <Typography variant="body2">ośrodek: <span style={{ fontWeight: 'bold' }}>{event?.resort_display}</span></Typography>
            </Stack>
            <Box height={20}/>
            <Divider />
            <Box height={20}/>
            <form onSubmit={formik.handleSubmit}>
              <Stack spacing={3}>
                <TextField
                  id="subject"
                  label="Tytuł"
                  value={formik.values.subject}
                  onChange={formik.handleChange}
                  error={formik.errors.subject && formik.touched.subject}
                  helperText={formik.errors.subject}
                />
                <TextField
                  id="message"
                  label="Wiadomość"
                  multiline
                  rows={8}
                  value={formik.values.message}
                  onChange={formik.handleChange}
                  error={formik.errors.message && formik.touched.message}
                  helperText={formik.errors.message}
                />
                { error
                  ? <Alert variant="outlined" severity="error">Nie udało się wysłać wiadomości</Alert>
                  : null}

                { loading
                  ? <>
                    <LinearProgress color="primary" />
                  </>
                  : <Button variant="contained" type="submit">Wyślij</Button>
                }

              </Stack>
            </form>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
